import React from 'react'
import { Modal, View } from 'oio-react'
import { Route, Switch, useHistory, useParams, useRouteMatch } from 'react-router-dom'
import { initiativeSettingsUrl } from 'config/constants/urls'
import InitiativeCreate from 'src/apps/Initiative/apps/Create'
import ModalRoute from 'src/components/utils/ModalRoute'
import { useOrganization } from 'src/graphql/hooks'
import DiscussionsHome from './apps/Home'
import DiscussionView from './apps/View'

const DiscussionsApp = () => {
   const history = useHistory()
   const { initiativeTypeSlug } = useParams()
   const match = useRouteMatch()

   const { organization } = useOrganization()
   const initiativeType = organization.initiativeTypes.find(t => (
      t.slug === initiativeTypeSlug
   ))

   return (
      <>
         <View
            minHeight="100vh"
            width="100%">
            <Switch>
               <Route exact path={match.path} component={DiscussionsHome} />
               <ModalRoute path={`${match.path}/create`}>
                  {({ open, onCloseComplete, onCloseTrigger }) => (
                     <Modal
                        borderRadius="5px"
                        width="300px[a-b] 480px[c-f]"
                        onCloseComplete={onCloseComplete}
                        onCloseTrigger={onCloseTrigger}
                        open={open}>
                        <InitiativeCreate
                           initiativeTypeId={initiativeType.id}
                           onCancelButtonClick={onCloseTrigger}
                           onCloseTrigger={onCloseTrigger}
                           onCreate={(initiative) => {
                              history.push(initiativeSettingsUrl(initiative))
                           }}
                        />
                     </Modal>
                  )}
               </ModalRoute>
               <Route path={`${match.path}/:initiativeSlug`} component={DiscussionView} />
            </Switch>
         </View>
      </>
   )
}

export default DiscussionsApp
